// appreset.ts
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const ApPreset = definePreset(Aura, {
  semantic: {
    primary: {
      '50': 'var(--color-brand-50)',
      '100': 'var(--color-brand-100)',
      '200': 'var(--color-brand-200)',
      '300': 'var(--color-brand-300)',
      '400': 'var(--color-brand-400)',
      '500': 'var(--color-brand-500)',
      '600': 'var(--color-brand-600)',
      '700': 'var(--color-brand-700)',
      '800': 'var(--color-brand-800)',
      '900': 'var(--color-brand-900)',
      '950': 'var(--color-brand-950)',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
      },
      dark: {
        primary: {
          color: '{primary.200}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.100}',
          activeColor: '{primary.50}',
        },
        focusRing: {
          color: '{primary.300}',
        },
      },
    },
  },

  components: {
    button: {
      colorScheme: {
        dark: {
          // Filled
          root: {
            primary: {
              background: '{primary.500}',
              hoverBackground: '{primary.400}',
              activeBackground: '{primary.600}',
              borderColor: '{primary.500}',
              hoverBorderColor: '{primary.400}',
              activeBorderColor: '{primary.600}',
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff',
              // Fixed: nested object instead of flat property
              focusRing: {
                color: '{primary.300}',
              },
            },
          },
          // Outlined
          outlined: {
            primary: {
              hoverBackground: 'color-mix(in srgb, {primary.200}, transparent 88%)',
              activeBackground: 'color-mix(in srgb, {primary.200}, transparent 80%)',
              borderColor: '{primary.300}',
              color: '{primary.200}',
            },
          },
          // Text / icon-only
          text: {
            primary: {
              hoverBackground: 'color-mix(in srgb, {primary.200}, transparent 88%)',
              activeBackground: 'color-mix(in srgb, {primary.200}, transparent 80%)',
              color: '{primary.200}',
            },
          },
        },
      },
    },

    tabs: {
      colorScheme: {
        dark: {
          tab: {
            color: '{surface.300}',
            hoverColor: '{surface.0}',
            activeColor: '{primary.200}',
          },
          tablist: { borderColor: '{surface.700}' },
          activeBar: { background: '{primary.300}' },
        },
      },
    },

    tag: {
      root: {
        fontSize: '0.75rem',
        fontWeight: '500',
      },
      colorScheme: {
        dark: {
          primary: { background: '{primary.500}', color: '#ffffff' },
          secondary: { background: '{surface.700}', color: '{surface.100}' },
        },
      },
    },
  },
});

export default ApPreset;